/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlNote = "/student-notes";
const urlCall = "/student-calls";
const urlEmail = "/student-emails";
const urlMeeting = "/student-meetings";
const urlLevelTest = "/student-level-tests";

const state = {
  addNote: false,
  callStudent: false,
  sendEmail: false,
  addMeeting: false,
  uid: null,
  replyInTo: null,
};

const actions = {
  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    if (payload.call_type) {
      return await axios.post(urlCall, payload);
    } else if (payload.email_address) {
      return await axios.post(urlEmail, payload);
    } else if (payload.meeting_type) {
      if (payload.meeting_type === "levelTest") {
        return await axios.post(urlLevelTest, payload);
      }
      return await axios.post(urlMeeting, payload);
    }
    return await axios.post(urlNote, payload);
  },

  /**
   * Update shift
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    if (payload.call_type) {
      return await axios.put(`${urlCall}/${id}`, payload);
    } else if (payload.email_address) {
      return await axios.put(`${urlEmail}/${id}`, payload);
    } else if (payload.meeting_type) {
      if (payload.meeting_type === "levelTest") {
        return await axios.put(`${urlLevelTest}/${id}`, payload);
      }
      return await axios.put(`${urlMeeting}/${id}`, payload);
    }
    return await axios.put(`${urlNote}/${id}`, payload);
  },

  async updatePinNote({ commit }, { id, payload }) {
    return await axios.put(`${urlNote}/${id}/pin`, payload);
  },

  /**
   * Delete shift
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, payload) {
    if (payload.type === "callout") {
      return await axios.delete(`${urlCall}/${payload.id}`);
    } else if (payload.email_address) {
      return await axios.delete(`${urlEmail}/${payload.id}`);
    } else if (payload.type === "meeting") {
      return await axios.delete(`${urlMeeting}/${payload.id}`);
    } else if (payload.type === "levelTest") {
      return await axios.delete(`${urlLevelTest}/${payload.id}`);
    }
    return await axios.delete(`${urlNote}/${payload.id}`);
  },

  /**
   * Send email
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async sendEmail({ commit }, payload) {
    return await axios.post(`${urlEmail}/send-email`, payload);
  },
  /**
   * set add note
   * @param commit
   * @param data
   */
  setAddNote({ commit }, data) {
    commit("SET_ADD_NOTE", data);
  },

  /**
   * set call student
   * @param commit
   * @param data
   */
  setCallStudent({ commit }, data) {
    commit("SET_CALL_STUDENT", data);
  },

  /**
   * set send email
   * @param commit
   * @param data
   */
  setSendEmail({ commit }, data) {
    commit("SET_SEND_EMAIL", data);
  },

  setAddMeeting({ commit }, data) {
    commit("SET_ADD_MEETING", data);
  },

  setUID({ commit }, uid) {
    commit("SET_UID", uid);
  },
};

const mutations = {
  SET_ADD_NOTE(state, data) {
    state.addNote = data;
  },
  SET_CALL_STUDENT(state, data) {
    state.callStudent = data;
  },
  SET_UID(state, data) {
    state.uid = data;
  },
  SET_SEND_EMAIL(state, data) {
    state.sendEmail = data.status || false;
    state.replyInTo = data.reply_in_to;
  },
  SET_ADD_MEETING(state, data) {
    state.addMeeting = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
